import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tab-details" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "items" }
const _hoisted_6 = { class: "item-header" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 0,
  class: "empty-data"
}

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";

import { tagList } from "@/common/api/rest/tag";
import {
  collectionTagList,
  collectionTagCreate,
  collectionTagDel,
} from "@/common/api/rest/collection-tag";

import type { TagType } from "@/common/types/tag";
import type { CollectionTagType } from "@/common/types/collection-tag";

import { sidebarListCheckbox, svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'tag',
  props: {
    collectionId: {}
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

const list = ref<TagType[]>([]);
const colletionTags = ref<CollectionTagType[]>([]);

const loading = ref(false);
const showSidebar = ref(false);

const added = computed(() => colletionTags.value.map((item) => item.tag_id));

async function fetchList() {
  await tagList({
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        list.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      loading.value = false;
    });
}

async function fetchItems() {
  await collectionTagList(props.collectionId, {
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        colletionTags.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function addItem(item: TagType) {
  await collectionTagCreate(props.collectionId, item.tag_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchItems();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function removeItem(data: TagType) {
  const item = colletionTags.value.find((item) => item.tag_id === data.tag_id);

  if (!item) return;

  await collectionTagDel(item.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchItems();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function openSidebar() {
  await fetchList();
  showSidebar.value = true;
}

function closeSidebar() {
  showSidebar.value = false;
}

onMounted(() => {
  fetchItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("collection.labels.tags")), 1),
        _createElementVNode("button", {
          class: "btn btn-default w-8 h-8 p-0",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openSidebar()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "bars",
            size: "1rem"
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colletionTags.value, (item, itemIndex) => {
          return (_openBlock(), _createElementBlock("div", {
            key: itemIndex,
            class: "item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
              _createElementVNode("button", {
                class: "btn btn-default w-5 h-5 p-0",
                onClick: ($event: any) => (removeItem(item as any))
              }, [
                _createVNode(_unref(svgIcon), {
                  icon: "close",
                  size: "0.75rem"
                })
              ], 8, _hoisted_8)
            ])
          ]))
        }), 128)),
        (!colletionTags.value.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(t)("collection.texts.empty_items")), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (showSidebar.value)
      ? (_openBlock(), _createBlock(_unref(sidebarListCheckbox), {
          key: 0,
          id: "tag",
          width: _ctx.$store.getters.mobile ? '90vw' : '40rem',
          open: showSidebar.value,
          loading: loading.value,
          "outside-close": true,
          title: _unref(t)('collection.labels.tags'),
          list: list.value,
          "field-id": "tag_id",
          "field-option": "name",
          added: added.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (closeSidebar())),
          "onAdd:item": addItem,
          "onRemove:item": removeItem
        }, null, 8, ["width", "open", "loading", "title", "list", "added"]))
      : _createCommentVNode("", true)
  ]))
}
}

})